import { render, staticRenderFns } from "./listClients.vue?vue&type=template&id=fe1b7e22&scoped=true&"
import script from "./listClients.vue?vue&type=script&lang=js&"
export * from "./listClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1b7e22",
  null
  
)

export default component.exports